// extracted by mini-css-extract-plugin
export var md = "_2n-4";
export var semantic = "_2n-5";
export var sm = "_2n-3";
export var text = "_2n-6";
export var toggleInput = "_2n-0";
export var toggleSwitch = "_2n-1";
export var xs = "_2n-2";